var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v("\n\t" + _vm._s(_vm.$t("dialogTextDownloadError")) + "\n\t"),
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "itemsWrapper" },
      _vm._l(_vm.items, function (item) {
        return _c("div", { key: item.id, staticClass: "preview imageNode" }, [
          item.thumb_url || item.url || item.full_url
            ? _c("img", {
                staticClass: "image",
                attrs: { src: item.thumb_url || item.url || item.full_url },
              })
            : _vm._e(),
          _vm._v(" "),
          item._error
            ? _c("span", [
                _vm._v("\n\t\t\t\t" + _vm._s(item._error.message) + "\n\t\t\t"),
              ])
            : _vm._e(),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }